$(document).ready(function() {
   $('.hero-slider').slick({
    arrows: false,
    dots: true,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 2000,
    slidesToShow: 1,
    adaptiveHeight: true
  });
  
  $('.work-slider .work-list').slick({
    dots: true,
    infinite: false,
    centerMode: true,
    centerPadding: '200px',
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
     responsive: [
      {
        breakpoint: 1200,
        settings: {
          centerPadding: '0px'
        }
      }
    ]
  });

$('.partner-slider .partner-list').slick({
    dots: true,
    arrows: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  $(document).on("click", ".FaqSec accordion-tab summary", function(){
    console.log($(this));
    $(this).parent().parent().siblings().find("details").removeAttr("open");
  });
  
  $(document).on("click", ".work-sec-btn a.scroll_top", function(e){
    e.preventDefault();
      $("html, body").animate({ scrollTop: 0 }, 1500);
  });
});


//
// tabbed content
// http://www.entheosweb.com/tutorials/css/tabs.asp
$(".tab-container .tab_content").hide();
// $(".tab-container .tab_content:first").show();
if ($(window).width() > 550){
  $('.tab-container').each(function(k,v){
    $(v).find('.tab_content:first').show();
  });
}else{
  $('.tab_content').hide();
  $(".delivery_metafields .tab_content:first").show();
}
$(window).resize(function(){
  if ($(window).width() > 550){
    $('.tab-container').each(function(k,v){
      $(v).find('.tab_content:first').show();
    });
  }else{
      $('.tab_content').hide();
      $(".delivery_metafields .tab_content:first").show();
  }
});

/* if in tab mode */
$("ul.tabs li").click(function() {
  var parent = $(this).parents('.tab-container');

  $(parent).find(".tab_content").hide();
  var activeTab = $(this).attr("rel");
  $(parent).find("#"+activeTab).fadeIn();

  $(parent).find("ul.tabs li").removeClass("active");
  $(this).addClass("active");

  $(parent).find(".tab_drawer_heading").removeClass("d_active");
  $(parent).find(".tab_drawer_heading[rel^='"+activeTab+"']").addClass("d_active");

});
/* if in drawer mode */
$(".tab_drawer_heading").click(function() {
  var parent = $(this).parents('.tab-container');

  $(parent).find(".tab_content").fadeOut();
 // $(".tab_drawer_heading").removeClass("d_active");
  var d_activeTab = $(this).attr("rel");
  if($(this).hasClass('d_active')){
    $(parent).find("#"+d_activeTab).fadeOut();
    $(this).removeClass("d_active");
  }else{
    $(".tab_drawer_heading").removeClass("d_active");
    $(parent).find("#"+d_activeTab).fadeIn();
    $(this).addClass("d_active");
  }
  

  $(parent).find("ul.tabs li").removeClass("active");
  $(parent).find("ul.tabs li[rel^='"+d_activeTab+"']").addClass("active");
});


/* Extra class "tab_last"
   to add border to right side
   of last tab */
$('ul.tabs li').last().addClass("tab_last");


// ---------------------------- 
// popup script

$(document).ready(function() {

  $('.sm_open').on('click', function(){
      var modal = $(this).attr('data-modal');
      var modaloverlaycolor = $(this).attr('data-overlay');
      var modaleffect = $(this).attr('data-effect');
      var modalheader = $(this).attr('data-header');
      var modalheadertype = $(this).attr('data-header-type');
      var modalcontent = $(this).attr('data-content');
      var modaliconside = $(this).attr('data-icons');
      var modalwrappercolor = $(this).attr('data-wrapper-color');

      $('#' + modal).addClass(modaloverlaycolor);
      $('#' + modal + ' .sm_content').addClass(modaleffect);
      $('#' + modal + ' .sm_content .sm_header').html(modalheader);
      $('#' + modal + ' .sm_content .sm_header').addClass(modalheadertype);
      $('#' + modal + ' .sm_content .sm_area_all').html(modalcontent);
      $('#' + modal + ' .sm_icon_menu').addClass(modaliconside);
      $('#' + modal + ' .sm_content').addClass(modalwrappercolor);
      $('#' + modal).fadeIn().css("display", "flex");
      setTimeout(function(){
          $('#'+modal + ' .sm_content').addClass('show');
      }, 400);        
  });

  $('.sm_close').on('click', function(){
      var $modal = $(this).parents('.slim_modal');
      closeModal($modal);  
  });

  $('.slim_modal').on('click', function(e) {
    if (e.target !== this)
      return;
      var $modal = $(this);
      closeModal($modal);
  });
  
  function closeModal($modal) {
      $modal.find('.sm_content').removeClass('show');
      setTimeout(function(){
          $modal.removeClass('red green tan none');
          $modal.find('.sm_content').removeClass('red green tan');
          $modal.find('.sm_icon_menu').removeClass('is_right is_left');
          $modal.find('.sm_header').removeClass('detached');
          $modal.fadeOut();
      }, 400);
  }
});

var variant_class = document.querySelector('.js-variant-drawer');
var drawer_class = document.querySelector('.cart-drawer-right');
document.addEventListener('click', function (event) {
  //console.log(event.target);
    if (!variant_class.contains(event.target) && !drawer_class.contains(event.target)){
      document.querySelector("body").classList.remove("variant-drawer-open");
      document.querySelector(".cart-drawer-right").classList.remove("cart-drawer-open");
    }
});


// open variant option drawer

(function () {
  const variantPopup = {
    selectors: {
      variantpopupButton: ".js-variant-drawer",
      variantDrawer: ".cart-drawer-right",
      variantDrawerCloseButton: ".custom-cart-drawer-close-btn",
    },
    init: function(){
      this.variantPopupButton = document.querySelector(this.selectors.variantpopupButton);
      this.variantDrawerCloseButton = document.querySelector(this.selectors.variantDrawerCloseButton);
      this.bindEvents();
    },
    bindEvents: function () {
       const _this = this;
      if(this.variantPopupButton  ||  this.variantDrawerCloseButton){

      this.variantPopupBtn = this.variantPopupButton.addEventListener("click", _this.handleVariantPopupOpen.bind(this),true);
      this.variantDrawerCloseBtn = this.variantDrawerCloseButton.addEventListener("click", _this.handleVariantPopupClose.bind(this),true);
      }
    },
    handleVariantPopupOpen: function (event) {
      document.querySelector(this.selectors.variantDrawer).classList.add("cart-drawer-open");
      document.querySelector("body").classList.add("variant-drawer-open");
    },
    handleVariantPopupClose: function (event) {
      document.querySelector(this.selectors.variantDrawer).classList.remove("cart-drawer-open");
      document.querySelector("body").classList.remove("variant-drawer-open");
    }
  }
  variantPopup.init();
})();



$(document).on("click", ".drawer_variants", function() {
  var swatch_name = $(this).find('.swatch-name').text();
  localStorage.setItem('swatch_name', swatch_name);  
});

setTimeout(function() {
  localStorage.removeItem('swatch_name');
  console.log('swatch_name removed from localStorage');
}, 15000); 

$(document).ready(function() {
  var storedSwatchName = localStorage.getItem('swatch_name');
  
  if (storedSwatchName) {
    var formattedSwatchName = storedSwatchName
      .toLowerCase()
      .replace(/\s*\(.*?\)\s*/g, '')  
      .replace(/\s+/g, '-');          
    
    formattedSwatchName = formattedSwatchName.replace(/-+$/, '');
    
    $('.js-variant-value').text(storedSwatchName);
    
    var image = `https://cerret.com/cdn/shop/files/swatch-${formattedSwatchName}_50x50.png`; 
    // $('label.selected_variant_label').css('background-image', `url(${image})`); 
    
  }

  /* PDP page image zoom fancybox KD start */
  $('[data-fancybox="gallery"]').fancybox({
    buttons: [
      "close"
    ],
    loop: false,
    protect: true
  });

  /* PDP page image zoom fancybox KD end */
});


